import { InfoCircleOutlined } from "@ant-design/icons";
import type { FC, ReactNode } from "react";

import { StyledInfoCard } from "./Styled";

interface InfoCardProps {
    status: "success" | "error";
    children: ReactNode;
}

export const InfoCard: FC<InfoCardProps> = ({ status, children }) => {
    return (
        <StyledInfoCard $status={status}>
            <InfoCircleOutlined />

            {children}
        </StyledInfoCard>
    );
};
